import React from 'react';
import { CheckIcon } from 'lucide-react';
import { BONUS_VALUE, bonuses } from '../data/edufis';
export function Bonuses() {
  return <section className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-36" data-mp="pjg4jxu631zc">
      <div className="mx-auto grid max-w-6xl gap-12 lg:grid-cols-12" data-id="element-37" data-mp="avv1u517f4ry">
        <div className="self-start lg:sticky lg:top-24 lg:col-span-4" data-id="element-38" data-mp="fu69c9411370">
          <p className="font-serif text-2xl italic leading-none text-red-700" data-id="element-39" data-mp="fs3dh8g70fud">Ma non è tutto!</p>
          <h2 className="mt-4 font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-40" data-mp="1whrla59ac66">
            5 bonus <em className="text-red-700" data-id="element-41" data-mp="3o1lferpctljg">senza costi aggiuntivi</em>
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-900/75" data-id="element-42" data-mp="3o3pum5spe6z1">
            Cinque risorse extra incluse insieme ai tuoi sei volumi – per gestire registro,
            supplenze, famiglie e classi numerose ancora più facilmente.
          </p>
        </div>

        <ol className="border-t border-slate-900/15 lg:col-span-8" data-id="element-43" data-mp="1r80f9x94qu90">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="grid grid-cols-[2.5rem_1fr] gap-x-5 border-b border-slate-900/15 py-9 sm:grid-cols-[3.5rem_1fr] sm:gap-x-8" data-id="element-44" data-mp="3id54555371a9" data-mpi={index}>
              <span className="font-serif text-5xl italic leading-none text-red-700 sm:text-6xl" aria-hidden="true" data-id="element-45" data-mp="3r6i6sysydh9j">
                {index + 1}
              </span>
              <div data-id="element-46" data-mp="3n5y6xngzvzjp">
                <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3" data-id="element-47" data-mp="2zfkf9y2bo2pn">
                  <h3 className="max-w-md font-serif text-2xl leading-tight text-slate-900 sm:text-3xl" data-id="element-48" data-mp="2zhf0ldhi9wu9">
                    <span className="sr-only" data-id="element-49" data-mp="38g8tasrpu32j">Bonus {index + 1} – </span>
                    {bonus.title}
                  </h3>
                  <span className="flex shrink-0 items-center gap-2" data-id="element-50" data-mp="33gw7mbckz21j">
                    <span className="text-sm text-slate-900/50" data-id="element-51" data-mp="nq19muqaauqb">
                      Valore <s data-id="element-52" data-mp="no6rtpab7iqg">{BONUS_VALUE}</s>
                    </span>
                    <span className="-rotate-3 rounded border-2 border-red-700 px-2 py-0.5 text-xs font-bold uppercase tracking-widest text-red-700" data-id="element-53" data-mp="ipwvhbcumc39">
                      Incluso
                    </span>
                  </span>
                </div>
                <p className="mt-3 max-w-xl leading-relaxed text-slate-900/75" data-id="element-54" data-mp="3ljl6dnq59pxm">{bonus.text}</p>
                <ul className="mt-4 grid max-w-xl gap-x-6 gap-y-2 sm:grid-cols-2" data-id="element-55" data-mp="3lhs049jg17q5">
                  {bonus.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-900/75" data-id="element-56" data-mp="2tsf3x0mybg56">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-57" data-mp="2xu0cwawd7aa3" />
                      {item}
                    </li>)}
                </ul>
                <p className="mt-4 max-w-xl font-serif text-lg italic leading-snug text-red-700" data-id="element-58" data-mp="37jtjsylkb180">
                  {bonus.benefit}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}